<template>
	<FormTitle
		v-if="title"
		:text="title"
		:required="required"
		:title-active="titleActive"
		:error="errorText ? true : false"
		:disabled="disabled"
		:kizuna-type="kizunaType"
	/>

	<div class="form_group relative" :class="[formClass, { error: errorClass }]">
		<!-- パスワード隠す -->
		<input
			v-show="isPasswordCheck"
			type="password"
			v-model="model"
			:disabled="disabled"
			:maxlength="maxlength"
			:class="formClass"
			class="input input-password w-full"
			autocomplete="off"
			tabindex="1"
			@focus="inputFocus"
			@blur="inputFocus"
		/>
		<!-- パスワード表示 -->
		<input
			v-show="!isPasswordCheck"
			type="text"
			v-model="model"
			:disabled="disabled"
			:maxlength="maxlength"
			:class="formClass"
			class="input input-password w-full"
			autocomplete="off"
			tabindex="1"
			@focus="inputFocus"
			@blur="inputFocus"
		/>

		<!-- パスワードの可視化切り替え -->
		<i
			v-if="isPasswordCheck"
			class="fa-solid fa-eye fa-fw form_group_password"
			@click="passwordCheck"
		/>

		<i
			v-else
			class="fa-solid fa-eye-slash fa-fw form_group_password"
			@click="passwordCheck"
		/>
	</div>
	<ErrorText :text="errorText" />
</template>

<script setup>
import FormTitle from "@/components/atoms/FormTitle.vue";
import ErrorText from "@/components/atoms/ErrorText.vue";

import { ref, computed, watch, watchEffect, onMounted } from "vue";

/* ---------------------------------------------------------------------------
	props
---------------------------------------------------------------------------- */
const props = defineProps({
	title: String,
	formClass: [String, Array],
	maxlength: Number,
	disabled: Boolean,
	required: Boolean,
	errorText: String,
	kizunaType: Number
});
const model = defineModel();
/* ---------------------------------------------------------------------------
data
---------------------------------------------------------------------------- */
const titleActive = ref(false);
const errorClass = ref("");
const isPasswordCheck = ref(true);
const supplementFlag = ref(false);
/* ---------------------------------------------------------------------------
	modelValueの値を監視
---------------------------------------------------------------------------- */
watch(
	() => model.value,
	(newValue, oldValue) => {
		enteredOrNotCheck(newValue);
	}
);
/* ---------------------------------------------------------------------------
	入力項目の判定
---------------------------------------------------------------------------- */
function enteredOrNotCheck(value) {
	// 必須かつ未入力の場合
	if (props.required && (value == "" || value == null)) {
		errorClass.value = "input-red";
		// 上記以外の場合
	} else {
		errorClass.value = "";
	}
}
/* ---------------------------------------------------------------------------
	その他
---------------------------------------------------------------------------- */
// パスワードの可視化
function passwordCheck() {
	isPasswordCheck.value = !isPasswordCheck.value;
}
/* ---------------------------------------------------------------------------
	捕捉事項の表示
---------------------------------------------------------------------------- */
function inputFocus() {
	titleActive.value = !titleActive.value;
}
/* ---------------------------------------------------------------------------
	mounted
---------------------------------------------------------------------------- */
onMounted(() => {
	// 入力項目の判定
	enteredOrNotCheck(model.value);
});
</script>
<style scoped lang="scss">
@use "/resources/css/_adjust.scss" as *;
.input {
	height: 40px;
	font-size: 1.4rem;
	position: relative;
	font-weight: normal;
	@include trans(0.3);
	padding: 10px 6px 8px;
	border-radius: 5px;
	border: 1px solid $bg-gray2;
	&:focus {
		@include trans(0.3);
		border-bottom: 1px solid $bg-green2;
	}
	&-password {
		padding: 12px 25px 10px 6px;
	}
	&.required {
		background-color: rgba(250, 183, 195, 0.3);
	}
}
.input::placeholder {
	color: #d9d9d9;
}
.form_group_password {
	top: 13px;
	right: 8px;
	cursor: pointer;
	font-size: 2rem;
	position: absolute;
}
input:disabled {
	color: $color-gray4;
	opacity: 1 !important;
	background: #eee;
}
.form_group {
	display: flex;
	align-items: flex-end;
}
.form_group.error .input {
	color: $baseTextColor;
	border-color: $bg-red2;
	background-color: rgba(250, 183, 195, 0.2);
}
</style>
